import { PageTransition } from '@/constant/transition'
import { isLoggedInAtom } from '@/state'
import { useAtom } from 'jotai'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container'
import Nav from 'react-bootstrap/Nav'
import Navbar from 'react-bootstrap/Navbar'
import { useNavigate, useLocation } from 'react-router-dom'
import { btn, frostedGlass } from './style.css'
import { HouseIcon, UserIcon } from 'lucide-react'

export default function NaviBottom() {
  const navigate = useNavigate()
  const location = useLocation()

  const [isLoggedIn] = useAtom(isLoggedInAtom)
  const isOnboardingPage = location.pathname.startsWith('/onboarding')

  return (
    <Navbar
      expand="lg"
      fixed="bottom"
      className={`flex-column ${frostedGlass}`}
      style={{ fontSize: '0.6rem' }}
    >
      {isLoggedIn && !isOnboardingPage && (
        <div className="d-inline-flex gap-3">
          <Button
            variant="outline-secondary"
            className={btn}
            onClick={() =>
              navigate('/', {
                state: { direction: PageTransition.FadeIn },
              })
            }
          >
            <HouseIcon />
            ホーム
          </Button>
          <Button
            variant="outline-secondary"
            className={btn}
            onClick={() =>
              navigate('/user/profile', {
                state: { direction: PageTransition.FadeIn },
              })
            }
          >
            <UserIcon />
            マイページ
          </Button>
        </div>
      )}
      <Container fluid className="d-flex justify-content-center">
        <Nav
          variant="tabs"
          className="d-flex flex-row flex-nowrap w-100 overflow-auto justify-content-center gap-1"
        >
          <Nav.Item>
            <Nav.Link href="https://labbase.co.jp/">運営会社</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link href="https://material.labbase.jp/pdf_contents/kosen/tos.pdf">
              利用規約
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link href="https://labbase.co.jp/about/privacy/">プライバシーポリシー</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link href="https://labbase.co.jp/contents/privacy/register/privacy.pdf">
              個人情報の取扱いについて
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link href="mailto:labbase_kosen@labbase.co.jp">お問い合わせ</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link href="https://business.labbase.jp/">採用担当者はこちら</Nav.Link>
          </Nav.Item>
        </Nav>
      </Container>
      <Container fluid className="d-flex justify-content-center">
        <Nav variant="tabs">© 2025 KOSEN NODE</Nav>
      </Container>
    </Navbar>
  )
}
